module.exports = __webpack_public_path__ + "static/media/action-four-rings.0368350e.svg";